import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {LocalStorage} from 'ngx-store';

@Injectable()
export class MemoryService {
    api: string = environment.apiUrl;
    @LocalStorage('loggedUser') loggedUser: any;
    @LocalStorage('userData') userData: any;
    lan = localStorage.getItem("lan")

    constructor(private http: HttpClient) {
        if (this.lan == null){ this.lan = 'en'}
    }

    async getBlocks(): Promise<any> {
        const headers = new HttpHeaders({'Content-Type': 'application/json', Authorization: 'Bearer ' + this.loggedUser.access_token});
        console.log(this.api + `memory_experiment/words?language=`+this.lan)
        return await this.http
            .get(this.api + `/memory_experiment/words?language=`+this.lan, {headers, observe: 'response'})
            .toPromise();
    }

    async save(body): Promise<any> {
        const headers = new HttpHeaders({'Content-Type': 'application/json', Authorization: 'Bearer ' + this.loggedUser.access_token});
        return await this.http
            .post(this.api + `/memory_experiment`, body, {headers, observe: 'response'})
            .toPromise();
    }
    async check_exp(): Promise<any> {
        const headers = new HttpHeaders({'Content-Type': 'application/json', Authorization: 'Bearer ' + this.loggedUser.access_token});
        return await this.http
            .get(this.api + `/checkMemory`, {headers, observe: 'response'}).toPromise();
      }
}